import React, { useEffect } from "react";
import useState from "react-usestateref";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { socket, SocketContext } from "./services.js/socket";
import backendService from "./services.js/backendService";
import ReactTooltip from "react-tooltip";
import SigninScreen from "././screens/SigninScreen";
import SignupScreen from "././screens/SignupScreen";
import EditProfileScreen from "./screens/EditProfileScreen";
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen";
import MainScreen from "./screens/MainScreen";
import LandingPage from "./screens/LandingPage";
import AboutPage from "./screens/AboutPage";
import ContactPage from "./screens/ContactPage";
import Forum from "./screens/Forum";
import AskQuestionPage from "./screens/AskQuestionPage";
import QuestionPage from "./screens/QuestionPage";
import MyQuestions from "./screens/MyQuestions";

function App() {
  const [rememberme, setRememberme, remembermeRef] = useState(true);
  const getRememberMe = (data) => {
    setRememberme(data);
    console.log("getRememberMe", remembermeRef.current);
  };

  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path="/edit-profile" element={<EditProfileScreen />} />
        <Route path="/home">
          <Route
            path=":screen"
            element={
              <SocketContext.Provider value={socket}>
                <ReactTooltip delayShow={500} delayHide={100} />
                <MainScreen />
              </SocketContext.Provider>
            }
          />
          <Route
            path=":screen/:conversationId"
            element={
              <SocketContext.Provider value={socket}>
                <ReactTooltip delayShow={500} delayHide={100} />
                <MainScreen />
              </SocketContext.Provider>
            }
          />
          <Route
            path=":conversationId"
            element={
              <SocketContext.Provider value={socket}>
                <ReactTooltip delayShow={500} delayHide={100} />
                <MainScreen />
              </SocketContext.Provider>
            }
          />
          <Route
            path=""
            element={
              <SocketContext.Provider value={socket}>
                <ReactTooltip delayShow={500} delayHide={100} />
                <MainScreen />
              </SocketContext.Provider>
            }
          />
        </Route>
        <Route path="/sign-up" element={<SignupScreen />} />
        <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
        <Route
          path="/login"
          element={
            <SocketContext.Provider value={socket}>
              <SigninScreen rememberme={getRememberMe} />{" "}
            </SocketContext.Provider>
          }
        />
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/forum">
          <Route path=":tag" element={<Forum />} />
          <Route path="" element={<Forum />} />
        </Route>
        <Route path="/askquestion" element={<AskQuestionPage />} />
        <Route path="/question/:qid" element={<QuestionPage />} />
        <Route path="/myquestions" element={<MyQuestions />} />
      </Routes>
    </Router>
  );
}

export default App;
